export enum ProductApprovalCheckStepFileType {
    RELEASE_ENGAGEMENT = 'RELEASE_ENGAGEMENT',
    RELEASE_ENGAGEMENT_SIGNED = 'RELEASE_ENGAGEMENT_SIGNED',
    INVOICE = 'INVOICE',
    CERTIFICATE = 'CERTIFICATE',
    CREDIT = 'CREDIT',
}
